// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"443":"about","631":"contact","686":"introduction","857":"shipping","929":"terms"}[chunkId] + "." + {"443":"d89a60ad","631":"e63acbad","686":"03075b2f","857":"760e4ae6","929":"5da6680e"}[chunkId] + ".css";
};